<template>
    <div id="modalDefault" class="modal modal-block-outside modal-pdv" @keydown.esc="closeModal()">
        <div class="modal-header">
            <div class="image-title">
                <h2>{{title}}</h2>
            </div>
            <div class="btnClose">
                <a href="#!" @click="closeModal()"
                    class="modal-action modal-close waves-effect waves-green btn-flat">
                    <span class="icon-Bistro-_Close"></span>
                </a>
            </div>
        </div>

        <div class="modal-body">
            <section>
                <slot></slot>
            </section>
        </div>
        <hr>
        <div class="modal-footer">
            <ButtonModals text="Cancelar" variant="return btn-modal" @handleClick="handleCancel" />
            <ButtonModals v-show="showConfirmButton" :text="confirmButtonText" variant="main btn-modal" @handleClick="handleConfirm" />
        </div>
    </div>
</template>

<script>
import ButtonModals from "@/features/shared/components/ButtonModals.vue"
import mixModals from '@/mixins/mixModals.vue';

export default {
    mixins: [mixModals],
    props: {
        title: {
            type: String,
        },
        confirmButtonText: {
            type: String,
        },
        showConfirmButton: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closeModal() {
            this.$emit('onClose');
        },
        handleCancel() {
            this.$emit('onCancel');
        },
        handleConfirm() {
            this.$emit('onConfirm');
        }
    },
    components: {
        ButtonModals
    }
}
</script>

<style lang="scss" scoped>

.modal-footer{
    display: flex;
    justify-content: flex-end;
    &>button {
    margin-right: 20px;  
    }
}
</style>
